import { VBScrollspy } from './scrollspy'
import { pluginFactory } from '../../utils/plugins'

const VBScrollspyPlugin = /*#__PURE__*/ pluginFactory({
  directives: { VBScrollspy }
})

export { VBScrollspyPlugin, VBScrollspy }
